import { render, staticRenderFns } from "./Therapies.vue?vue&type=template&id=df71a8aa&scoped=true"
import script from "./Therapies.vue?vue&type=script&lang=js"
export * from "./Therapies.vue?vue&type=script&lang=js"
import style0 from "./Therapies.vue?vue&type=style&index=0&id=df71a8aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df71a8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df71a8aa')) {
      api.createRecord('df71a8aa', component.options)
    } else {
      api.reload('df71a8aa', component.options)
    }
    module.hot.accept("./Therapies.vue?vue&type=template&id=df71a8aa&scoped=true", function () {
      api.rerender('df71a8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/record/Therapies.vue"
export default component.exports